import queryString from 'qs';

import { apiClient } from '@/libs/http-client';

import createBatchDto from '../dto/batch';
import { ICreateBatch, IGetBatches } from '../types/api';
import { IBatch } from '../types/batch';
import {
  serializeCreateBatchesParams,
  serializeGetBatchesParams,
} from '../utils/serialize-requests';

// endpoint to generate histogram graph (used in report generation)
const histogramUrl = import.meta.env.VITE_HISTOGRAM_GENERATION_URL;

export const getBatch = async (id: string): Promise<IBatch> => {
  return apiClient()
    .get(`batches/${id}`)
    .json()
    .then((response: any) => createBatchDto(response));
};

export const getBatches = async (
  params: IGetBatches,
): Promise<{ data: IBatch[]; pagination: { total: number; total_pages: number } }> => {
  return apiClient()
    .get('batches', { searchParams: serializeGetBatchesParams(params) })
    .json()
    .then((response: any) => ({
      data: response.data.map((d: unknown) => createBatchDto(d)),
      pagination: response.pagination,
    }));
};

export const createBatch = async (data: ICreateBatch): Promise<IBatch> => {
  return apiClient()
    .post('batches', {
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      body: queryString.stringify(serializeCreateBatchesParams(data)),
    })
    .json()
    .then((response: any) => createBatchDto(response));
};

export const updateBatch = (
  id: string,
  data: Partial<Omit<IBatch, 'id'>>,
): Promise<IBatch> => {
  return apiClient()
    .put(`batches/${id}`, {
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      body: queryString.stringify(serializeCreateBatchesParams(data)),
    })
    .json();
};

export const getConzBatchHistogram = async (batch: IBatch): Promise<Blob> => {
  return apiClient()
    .post('histogram/conz', {
      prefixUrl: histogramUrl,
      json: { meanDia: batch.resultStat.meanDia?.hist[0] ?? [] },
    })
    .blob();
};

export const getConzViabBatchHistogram = async (batch: IBatch): Promise<Blob> => {
  return apiClient()
    .post('histogram/conz_viab', {
      prefixUrl: histogramUrl,
      json: {
        alive: batch.resultStat.meanDiaAlive?.hist[0] ?? [],
        dead: batch.resultStat.meanDiaDead?.hist[0] ?? [],
      },
    })
    .blob();
};

export const unlinkBatchFromFermentation = async (batchId: string): Promise<void> => {
  return apiClient().post(`fermentation-unlink/${batchId}`).json();
};

export const linkBatchFromFermentation = async ({
  batchId,
  fermentationId,
}: {
  batchId: string;
  fermentationId: string;
}): Promise<void> => {
  return apiClient()
    .post(`fermentation-link/${batchId}`, {
      json: {
        fermentation_id: fermentationId,
      },
    })
    .json();
};
